import e from"styled-components";import{COLORS as t}from"../../../constants/Theme.js";e.div`
	flex-direction: row;
	margin-left: 24px;
	display: flex;
	flex: 1;
	width: 100%;
`;const o=e.div`
	display: flex;
	border-left-width: 1px;
	border-left-style: solid;
	border-left-color: ${t.stroke.primary};
	flex: 1;
	padding-left: 16px;
	padding-bottom: 24px;
	margin-left: 24px;
`;export{o as LinedContainer};
